export default {
  title: 'Data Check',
  subtitle: 'See the data of your approved Data Template as charts before modeling starts. Look for missing periods, sudden spikes and series that don\'t match what you know about your business.',
  uploadedBy: 'uploaded by {name} on {date}',
  templateApprovedBy: 'approved by {name} on {date}',
  statusPending: 'Pending review',
  statusApproved: 'Approved',
  validationWarnings: 'This template was approved with {count} validation warning. | This template was approved with {count} validation warnings.',
  viewInDataUpload: 'See them in Data Upload',

  // States
  noTemplateTitle: 'No approved Data Template yet',
  noTemplateText: 'Upload your Data Template and approve it in Data Upload, then come back here to check it.',
  goToDataUpload: 'Go to Data Upload',
  loadingTitle: 'Preparing your data…',
  loadingText: 'We are reading your template and adding up every series.',
  loadingSlowText: 'Large templates can take a few minutes. You can keep this page open.',
  errorTitle: 'We couldn\'t prepare your data',
  errorText: 'Please try again. If it keeps failing, contact our team.',
  errorPermission: 'You don\'t have access to the Data Check of this model.',
  errorNotApproved: 'The Data Template is no longer approved. Approve it in Data Upload first.',
  errorDisabled: 'Data upload is not enabled for this model.',
  retry: 'Try again',

  // Tiles
  tileDateRange: 'Total Date Range',
  tileFrequency: 'Sales frequency',
  tileSeries: 'Series',
  tileSheetsWithData: 'Sheets with data',
  tileSheetsOf: '{count} of {total}',
  tileFlagged: 'Series to review',
  tileNone: 'None',
  frequencyDaily: 'Daily',
  frequencyWeekly: 'Weekly',
  frequencyMonthly: 'Monthly',
  frequencyQuarterly: 'Quarterly',
  frequencyYearly: 'Yearly',
  frequencyIrregular: 'Irregular',

  // Sheet groups
  groupKpi: 'Sales & KPIs',
  groupOwn: 'Own marketing',
  groupCompetition: 'Competition',
  groupContext: 'Market & context',
  groupSpecialDates: 'Special dates',
  specialDatesEmpty: 'No special dates in this template',
  eventsHeaderStart: 'Start',
  eventsHeaderEnd: 'End',
  eventsHeaderEvent: 'Event',
  eventsHeaderDescription: 'Description',
  eventsTruncated: 'Only the first 500 special dates are listed.',

  // Approval
  approvalTitle: 'Approve the Data Check',
  approvalText: 'When the charts look right, approve the Data Check. Our team will be notified and will continue with the model.',
  approvalCheckbox: 'I reviewed the charts and the data looks right',
  approveButton: 'Approve Data Check',
  approvedTitle: 'Data Check approved',
  approvedText: 'Approved by {name} on {date}. Our team has been notified.',
  markAsPending: 'Set back to pending',
  approvedSnackbar: 'Data Check approved. Our team has been notified.',
  pendingSnackbar: 'Data Check set back to pending.',
  approvalError: 'The Data Check could not be updated. Please try again.',

  // Footer
  generatedAt: 'Charts prepared on {date}',
  partialNotice: 'Some details were left out to keep the page fast.'
}
